import { render, staticRenderFns } from "./CteVeiculoDetalhes.vue?vue&type=template&id=63548662"
import script from "./CteVeiculoDetalhes.vue?vue&type=script&lang=js"
export * from "./CteVeiculoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports